<template>
  <div class="page-content">
    <div class="page-body">
      <div class="dashboard-navigation">
        <div class="dashboard-content dashboard-margin">
          <div class="app-standardpage-header mb-2">
            {{$t('polls.dashboard')}}
            <span class="go-to-dashboard"> 
              <BtnLink
                @click.native="goToMembership()"
                class="flex-column border-radius font-weight-500"
                :label="$t('polls.checkMembershipStatus')"
              />
            </span>
          </div>
          <NavigationTabs v-model="currentTabComponent" :navItems="navItems" />
        </div>
      </div>

      <div class="dashboard-content">
        <div class="dashboard-margin">
          <component v-bind:is="currentTabComponent"></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import MyPolls from '@/components/MyPolls.vue';
import MyContacts from '@/components/MyContacts.vue';
import MyOldContacts from '@/components/MyOldContacts.vue';
import NavigationTabs from '@/components/UI/NavigationTabs';

export default {
  name: 'MyDashboard',
  components: {
    MyPolls,
    MyContacts,
        MyOldContacts,
    NavigationTabs,
  },

  data() {
    return {
      currentTabComponent: 'my-polls',
      sidePanelDialog: 'edit-profile',
      // tabSelection : 'polls',
      visibleDropdown: true,
    };
  },

  methods: {
    goToMembership() {
      this.$router.push('/membership');
    }
  },

  computed: {
    navItems() {
      let items = [
        { code: 'my-polls', label: this.$t('polls.myPolls') },
        { code: 'my-contacts', label: this.$t('contacts.myContacts') },
        // { code: 'my-old-contacts', label: 'Old Contacts' },
      ];
      return items;
    },
  },
  mounted() {
    this.$store.commit('setVisibleNav', true);
    const viewportContent = "width=device-width initial-scale=1" 
    document.querySelector("meta[name='viewport']").setAttribute("content", viewportContent) 
  },
};
</script>

<style lang="scss">
@import '@/styles/style.scss';

.page-content {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-color: $very-light-grey;
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.page-body {
  overflow: auto;
}

.dashboard-navigation {
  background-color: white;
  padding-top: 68px;
  flex-shrink: 0;
  flex-grow: 0;
  }

.dashboard-content {
  display: flex;
  flex-direction: column;
}

.dashboard-margin {
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding-left: $mobile-margin-left;
  padding-right: $mobile-margin-left;

}

@media screen and (min-width: 960px) {
  .dashboard-margin {
    margin-left: $desktop-margin-left !important;
    padding: 0px;
  }
}
</style>
